<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <div v-else>
    <v-form ref="shopForm" v-model="valid">
      <v-container fluid class="pt-6">
        <v-row>
  
  </v-row>
        <v-row>
          <v-col cols="12" lg="12" class="order-lg-0 order-1">
            <v-card class="mx-auto EK-card IMThemeGray rounded-xl rounded-tr-0">
              <v-col>
                <v-row> 
                    <v-col lg="12">
                        <div style="max-width: 100%" class="mx-auto">
                            <div class="IMThemeOrange text-white p-3 rounded-xl rounded-tl-0 mx-4">
                                <h6 class="m-0 text-center">الصور الملحقة للمشترك</h6>
                                <hide-toggler v-model="formD.hiddenAttributes[24]"></hide-toggler>
                            </div>
                            <v-row>
                                <div v-for="(img, index) in shopForm.subImages.slice(
                  (imagesPage - 1) * pageSize,
                  (imagesPage - 1) * pageSize + pageSize
                )"
                                     :key="index">
                                    <v-col >

                                        <v-card class="mt-6" rounded="xl" :elevation="12">
                                            <template v-if="img.state != 2">
                                                <!-- delete in backend -->
                                                <v-btn color="error"
                                                       @click="cancelImg(index + (imagesPage - 1) * pageSize)"
                                                       type="button"
                                                       class="rounded-circle AClass">
                                                    <v-icon>mdi-close</v-icon>
                                                </v-btn>
                                                <hide-toggler v-model="img.isHidden" class="rounded-circle BClass"></hide-toggler>

                                                <img :src="
                        !img
                          ? placeholder
                          : !!img.path
                          ? domainHost + img.path.replace('~', '')
                          : img.base64
                      "
                                                     :alt="'store image' + index + (imagesPage - 1) * pageSize"
                                                     class="w-100 border rounded-t-xl"
                                                     style="object-fit: contain; height: 150px" />
                                                <v-textarea class="mb-0"
                                                            dense
                                                            solo
                                                            hide-details
                                                            placeholder="يمكنك كتابة وصف الصورة هنا ..."
                                                            color="IMThemeOrange"
                                                            rows="2"
                                                            v-model="img.description">
                                                </v-textarea>
                                            </template>
                                        </v-card>
                                    </v-col>
                                </div>

                            </v-row>
                           
                            <v-pagination color="IMThemeGray"
                                          v-model="imagesPage"
                                          :total-visible="14"
                                          :length="Math.ceil(shopForm.subImages.length / pageSize)"
                                          class="w-100"
                                          @input="nextPage"></v-pagination>
                            <div v-if="shopForm.imgSubsState == 1">
                                <p class="p-2 text-warning">المشترك ليس لديه اشتراك صور</p>
                            </div>
                            <div v-else-if="shopForm.imgSubsState == 3 || shopForm.mainSubsState == 3">
                                <p class="p-2 text-warning">
                                    اشتراك الصور أو اشتراك بطاقة المعلومات لهذا المشترك منتهي
                                </p>
                            </div>
                            <drag-drop-image v-else
                                             title="أضف صور"
                                             :mul="true"
                                             @uploaded="uploadSubImgs"
                                             class="overflow-hidden"
                                             style="height: 38px; justify-content: flex-end; padding: 7px"></drag-drop-image>
                        </div>
                    </v-col>
                  
                </v-row>
           
                <v-row>
                  <v-col cols="12" md="6" class="text-right">
                    <v-col cols="12" class="text-center">
                      <label for="mainImg">صورة المشترك</label>
                 
                      <drag-drop-image
                        class="AddMainImg overflow-hidden p-2 mt-0"
                        title="أضف صورة"
                        @uploaded="uploadMainImg"
                        :mul="false"
                        style="height: 38px; justify-content: flex-end"
                      ></drag-drop-image>
                      <img
                        id="mainImg"
                        :src="
                          !!shopForm.mainImage[0] &&
                          (!!shopForm.mainImage[0].path ||
                            !!shopForm.mainImage[0].defaultPath ||
                            !!shopForm.mainImage[0].base64)
                            ? !!shopForm.mainImage[0].path
                              ? domainHost + shopForm.mainImage[0].path.replace('~', '')
                              : !!shopForm.mainImage[0].defaultPath
                              ? placeholder
                              : !!shopForm.mainImage[0].base64
                              ? shopForm.mainImage[0].base64
                              : placeholder
                            : placeholder
                        "
                        alt="main Image"
                        class="rounded-xl w-100 border"
                        style="object-fit: cover; height: 300px; max-width: 300px"
                      />
                      <hide-toggler v-model="formD.hiddenAttributes[23]"></hide-toggler>
                    </v-col>
                    <v-row>
                      <v-col cols="12" sm="6" md="12">
                        <label for="storeName">اسم المشترك</label>
                        <v-text-field
                          id="storeName"
                          v-model="shopForm.name"
                          :rules="storeName"
                          class="rounded-tr-0"
                          rounded
                          dense
                          solo
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="storeType">نوع المشترك</label>
                        <v-autocomplete
                          id="storeType"
                          v-model="shopForm.shopType"
                          dense
                          rounded
                          color="IMThemeGray"
                          item-color="IMThemeGray"
                          solo
                          class="rounded-tr-0"
                          :items="shopTypes"
                          item-value="id"
                          item-text="name"
                        >
                          <template v-slot:item="data">
                            <v-list-item-content
                              v-text="data.item.name"
                            ></v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="visitCount">عدد الزيارات</label>
                        <v-text-field
                          id="visitCount"
                          :value="shopForm.visitCount"
                          readonly
                          dense
                          rounded
                          color="IMThemeGray"
                          item-color="IMThemeGray"
                          solo
                          class="rounded-tr-0"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="areaId">المنطقة</label>
                        <div class="d-flex">
                          <v-autocomplete
                            id="areaId"
                            v-model="shopForm.areaId"
                            :rules="areaId"
                            dense
                            rounded
                            color="IMThemeGray"
                            item-color="IMThemeGray"
                            solo
                            class="rounded-tr-0"
                            :items="areasList"
                            item-text="name"
                            item-value="id"
                          >
                            <template v-slot:item="data">
                              <v-list-item-content
                                v-text="data.item.name"
                              ></v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="address">عنوان المشترك</label>
                        <div class="d-flex">
                          <v-text-field
                            id="address"
                            v-model="shopForm.address"
                            class="rounded-tr-0"
                            rounded
                            dense
                            solo
                          ></v-text-field>
                          <hide-toggler
                            v-model="formD.hiddenAttributes[3]"
                          ></hide-toggler>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="categoriesIds">تصنيف المشترك</label>
                        <v-autocomplete
                          id="categoriesIds"
                          v-model="shopForm.categoriesIds"
                          :rules="categoriesIds"
                          chips
                          deletable-chips
                          dense
                          multiple
                          rounded
                          class="rounded-tr-0"
                          color="IMThemeGray"
                          item-color="IMThemeGray"
                          small-chips
                          solo
                          :items="categoriesList"
                          item-value="id"
                          item-text="name"
                        >
                          <template v-slot:item="data">
                            <v-list-item-content
                              v-text="data.item.name"
                            ></v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="6" md="12">
                        <v-switch
                          v-model="shopForm.isCustom"
                          label="أوقات دوام مخصصة"
                          class="mt-0"
                          color="IMThemeOrange"
                          dark
                        ></v-switch>
                        <div v-if="!shopForm.isCustom">
                          <label for="schedule">أوقات الدوام</label>
                          <hide-toggler
                            v-model="formD.hiddenAttributes[21]"
                          ></hide-toggler>
                          <v-autocomplete
                            id="schedule"
                            v-model="shopForm.scheduleTemplateId"
                            dense
                            rounded
                            class="rounded-tr-0"
                            color="IMThemeGray"
                            item-color="IMThemeGray"
                            solo
                            :items="[
                              {
                                id: null,
                                name: 'غير محدد',
                              },
                              ...schedulesList,
                            ]"
                            item-text="name"
                            item-value="id"
                          >
                            <template v-slot:append-outer>
                              <v-btn
                                @click="setAddTimeDialog(true)"
                                class="white"
                                color="IMThemeGray"
                                icon
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </template>
                            <template v-slot:item="data">
                              <v-list-item-content
                                class="border-bottom text-right"
                                v-text="data.item.name"
                              ></v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </div>
                        <div v-if="shopForm.isCustom">
                          <label for="customDaysSelect">تحديد أوقات الدوام المخصصة</label>
                          <v-select
                            id="customDaysSelect"
                            rounded
                            multiple
                            :rules="[
                              (v) =>
                                (!!v && !!v.length) || 'يجب تحديد يوم واحد على الاقل',
                            ]"
                            chips
                            deletable-chips
                            color="IMThemeGray"
                            item-color="IMThemeGray"
                            :items="daysList"
                            item-text="name"
                            item-value="id"
                            dense
                            solo
                            v-model="selectedCustomDaysWatcher"
                          ></v-select>
                          <div
                            v-for="(day, index) in shopForm.customSchedules"
                            :key="index"
                          >
                            <div class="text-white">
                              يوم
                              {{ daysList[day.dayofWeek - 1].name }}
                            </div>
                            <v-row>
                              <v-col cols="4">
                                <label for="open">من</label>
                                <v-menu
                                  :ref="'menu_from_' + index"
                                  v-model="selectedCustomDaysMenus[index].from"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="day.open"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      id="open"
                                      v-model="day.open"
                                      v-bind="attrs"
                                      v-on="on"
                                      readonly
                                      :rules="fromTime"
                                      solo
                                      dense
                                      rounded
                                      class="rounded-tl-0"
                                      color="IMThemeGray"
                                    ></v-text-field>
                                  </template>
                                  <v-time-picker
                                    v-if="selectedCustomDaysMenus[index].from"
                                    v-model="day.open"
                                    full-width
                                    locale="ar-sy"
                                    color="IMThemeGray"
                                    @click:minute="
                                      $refs['menu_from_' + index][0].save(day.open)
                                    "
                                  ></v-time-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="4">
                                <label for="toTime">إلى</label>
                                <v-menu
                                  :ref="'menu_to_' + index"
                                  v-model="selectedCustomDaysMenus[index].to"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="day.close"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="day.close"
                                      v-bind="attrs"
                                      v-on="on"
                                      readonly
                                      :rules="toTime"
                                      solo
                                      dense
                                      rounded
                                      class="rounded-tl-0"
                                      color="IMThemeGray"
                                    ></v-text-field>
                                  </template>
                                  <v-time-picker
                                    v-if="selectedCustomDaysMenus[index].to"
                                    v-model="day.close"
                                    full-width
                                    locale="ar-sy"
                                    color="IMThemeGray"
                                    @click:minute="
                                      $refs['menu_to_' + index][0].save(day.close)
                                    "
                                  ></v-time-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="4" class="align-items-end d-flex">
                                <v-checkbox
                                  class="mt-0 pb-3"
                                  v-model="day.is24H"
                                  @change="setOpenClose(day)"
                                  color="IMThemeOrange"
                                  dark
                                  label="24 ساعة"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                        <v-dialog v-model="timeDialog" max-width="500">
                          <v-card class="rounded-xl">
                            <v-card-title
                              class="position-absolute pt-2 px-2"
                              style="z-index: 1"
                            >
                              <v-btn icon color="white" @click="setAddTimeDialog(false)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </v-card-title>
                            <actionSchedule
                              @close="
                                timeDialog = false;
                                shopForm.scheduleTemplateId = schedulesList[0].id;
                              "
                              id="-1"
                            />
                          </v-card>
                        </v-dialog>
                      </v-col>

                      <v-col cols="12" sm="6" md="12">
                        <label for="workTime">حالة الإشتراك</label>
                        <v-card-text class="white rounded-xl rounded-tr-0">
                          <v-col cols="12" class="text-right text-lg-center">
                            <v-row>
                              <v-col lg="3" class="text-center">
                                <label
                                  style="color: #212121 !important; white-space: nowrap"
                                  > بطاقة المعلومات</label
                                >
                                <subscription-state
                              
                                  :type="shopForm.mainSubsState"
                                  :isSmall="false"
                                ></subscription-state>
                              </v-col>
                              <v-col lg="3" class="text-center">
                                <label style="color: #212121 !important">الإشعار</label>
                                <subscription-state
                           
                                  :type="shopForm.notiSubsState"
                                  :isSmall="false"
                                ></subscription-state>
                              </v-col>
                              <v-col lg="3" class="text-center">
                                <label style="color: #212121 !important">الصور</label>
                                <subscription-state
                           
                                  :type="shopForm.imgSubsState"
                                  :isSmall="false"
                                ></subscription-state>
                              </v-col>
                              <v-col lg="3" class="text-center">
                                <label style="color: #212121 !important">العروض</label>
                                <subscription-state
                            
                                  :type="shopForm.offerSubsState"
                                  :isSmall="false"
                                ></subscription-state>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-card-actions class="justify-content-center">
                            <v-btn @click="goToSub" small color="secondary">
                              <v-icon small>mdi-arrow-left</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="6" class="text-right">
                    <v-col cols="12" class="text-right text-lg-center">
                      <v-row>
                        <v-col cols="12" md="7">
                          <label for="registerDate">تاريخ بداية الإشتراك</label>
                          <v-menu
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                id="registerDate"
                                v-model="shopForm.subscribeStartDate"
                                readonly
                                class="rounded-tr-0"
                                rounded
                                color="IMThemeGray"
                                dense
                                solo
                                v-bind="attrs"
                                v-on="on"
                                append-icon="mdi-calendar"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="shopForm.subscribeStartDate"
                              @input="dateMenu = false"
                              locale="ar-sy"
                              color="IMThemeGray"
                              @change="
                                ChangeEndDate(shopForm.subscribeStartDate, selectedPeriod)
                              "
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" md="5">
                          <label for="period">مدة الاشتراك</label>
                          <v-select
                            id="period"
                            v-model="selectedPeriod"
                            class="rounded-tr-0"
                            rounded
                            color="IMThemeGray"
                            item-color="IMThemeGray"
                            :items="periodsItems"
                            item-text="text"
                            item-value="value"
                            dense
                            solo
                            @change="
                              ChangeEndDate(shopForm.subscribeStartDate, selectedPeriod)
                            "
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <label for="endDate">تاريخ الإنتهاء</label>
                          <v-text-field
                            id="endDate"
                            v-model="shopForm.subscribeEndDate"
                            class="rounded-tr-0"
                            disabled
                            rounded
                            color="IMThemeGray"
                            dense
                            solo
                            append-icon="mdi-calendar"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <div class="overflow-hidden">
                        <label for="position">الاحداثيات</label>
                        <v-btn
                          color="error"
                          class="float-left"
                          @click="
                            shopForm.longitude = null;
                            shopForm.latitude = null;
                          "
                          >تهيئة</v-btn
                        >
                      </div>
                      <v-row>
                        <v-col cols="12" lg="6">
                          <label for="longitude">خط الطول</label>
                          <v-text-field
                            id="longitude"
                            v-model="shopForm.longitude"
                            class="rounded-tr-0"
                            rounded
                            dense
                            solo
                            readonly
                            dir="ltr"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6">
                          <label for="latitude">خط العرض</label>
                          <div class="d-flex">
                            <v-text-field
                              id="latitude"
                              v-model="shopForm.latitude"
                              class="rounded-tr-0"
                              rounded
                              dense
                              solo
                              readonly
                              dir="ltr"
                            ></v-text-field>
                            <hide-toggler
                              v-model="formD.hiddenAttributes[9]"
                            ></hide-toggler>
                          </div>
                        </v-col>
                        <v-col class="text-center">
                          <v-btn
                            rounded
                            color="info"
                            class="rounded-tr-0"
                            @click="isShowMap()"
                          >
                            <v-icon>mdi-map</v-icon>
                            تحديد الاحداثيات
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <label for="description">الوصف</label>
                      <v-textarea
                        id="description"
                        v-model="shopForm.description"
                        color="secondary"
                        dense
                        rounded
                        rows="6"
                        solo
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <label for="contactInfo">معلومات التواصل</label>
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12" lg="12">
                            <div class="d-flex">
                              <v-text-field
                                v-model="shopForm.mobileNumber"
                                @change="ConvertToArabic(shopForm.mobileNumber)"
                                solo
                                append-icon="mdi-cellphone-basic"
                                dense
                                color="dark"
                                rounded
                                label="موبايل"
                                class="rounded-tr-0 w-100"
                                dir="ltr"
                                @input="disableBtn = true"
                              ></v-text-field>
                              <hide-toggler
                                v-model="formD.hiddenAttributes[5]"
                              ></hide-toggler>
                            </div>
                          </v-col>
                          <v-col cols="12" lg="4"> </v-col>
                          <v-col cols="12" sm="6" md="12">
                            <div class="d-flex">
                              <v-text-field
                                v-model="shopForm.phoneNumber"
                                dense
                                color="dark"
                                solo
                                append-icon="mdi-phone"
                                rounded
                                label="هاتف"
                                class="rounded-tr-0"
                                dir="ltr"
                              ></v-text-field>

                              <hide-toggler
                                v-model="formD.hiddenAttributes[4]"
                              ></hide-toggler>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="6" md="12">
                            <div class="d-flex">
                              <v-text-field
                                v-model="shopForm.email"
                                :rules="email"
                                dense
                                dir="ltr"
                                class="ltr-label rounded-tr-0"
                                solo
                                color="dark"
                                label="Email"
                                rounded
                                append-icon="mdi-email"
                              ></v-text-field>
                              <hide-toggler
                                v-model="formD.hiddenAttributes[7]"
                              ></hide-toggler>
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <div
                              class="d-flex align-items-center my-2"
                              style="align-items: center"
                            >
                              <label>معلومات تواصل إضافية</label>
                              <hide-toggler
                                v-model="formD.hiddenAttributes[31]"
                              ></hide-toggler>
                            </div>

                            <v-autocomplete
                              id="storeContactInfo"
                              dense
                              rounded
                              color="IMThemeGray"
                              item-color="IMThemeGray"
                              class="rounded-tr-0"
                              solo
                              v-model="contactInfoType"
                              :items="shopContactInfoType"
                              ref="contactInfoType"
                              item-value="id"
                              item-text="name"
                            >
                              <template v-slot:append-outer>
                                <v-btn
                                  icon
                                  class="info"
                                  @click="unShiftSocial(contactInfoType)"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </template>
                            </v-autocomplete>
                            <v-row>
                              <v-col
                                cols="12"
                                v-for="(contactInfo, index) in shopForm.shopContactInfos"
                                :key="index"
                              >
                                <v-divider></v-divider>
                                <label>{{
                                  contactInfo.infoType == 6
                                    ? "اسم الرابط"
                                    : contactInfo.name
                                }}</label>

                                <div class="d-flex">
                                  <v-text-field
                                    v-if="contactInfo.infoType == 6"
                                    v-model="contactInfo.name"
                                    dense
                                    class="rounded-tr-0"
                                    solo
                                    color="dark"
                                    rounded
                                  ></v-text-field>
                                </div>
                                <div class="d-flex">
                                  <v-text-field
                                    v-model="contactInfo.link"
                                    :rules="link"
                                    dir="ltr"
                                    dense
                                    class="rounded-tr-0"
                                    solo
                                    color="dark"
                                    :append-icon="
                                      'mdi-' +
                                      (contactInfo.infoType == 9
                                        ? 'email'
                                        : contactInfo.infoType == 8
                                        ? 'phone'
                                        : contactInfo.infoType == 7
                                        ? 'cellphone'
                                        : contactInfo.infoType == 5
                                        ? 'telegram'
                                        : contactInfo.infoType == 4
                                        ? 'whatsapp'
                                        : contactInfo.infoType == 3
                                        ? 'twitter'
                                        : contactInfo.infoType == 2
                                        ? 'instagram'
                                        : contactInfo.infoType == 1
                                        ? 'facebook'
                                        : 'wan')
                                    "
                                    :suffix="
                                      contactInfo.infoType == 7 ||
                                      contactInfo.infoType == 8 ||
                                      contactInfo.infoType == 9
                                        ? ''
                                        : contactInfo.infoType == 5
                                        ? 'https://t.me/'
                                        : contactInfo.infoType == 4
                                        ? 'https://wa.me/+'
                                        : contactInfo.infoType == 3
                                        ? 'https://twitter.com/@'
                                        : contactInfo.infoType == 2
                                        ? 'https://www.instagram.com/'
                                        : contactInfo.infoType == 1
                                        ? 'https://www.facebook.com/'
                                        : 'https://'
                                    "
                                    rounded
                                  >
                                    <template v-slot:append-outer>
                                      <v-btn
                                        color="error"
                                        icon
                                        @click="removeInfoSocial(index)"
                                      >
                                        <v-icon>mdi-delete-empty </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </div>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="8">
                            <div class="align-items-baseline float-right">
                              <label class="ml-2" for="otp">رمز المشترك</label>
                              <v-text-field
                                id="otp"
                                v-model.number="shopForm.otp"
                                dense
                                color="dark"
                                solo
                                rounded
                                label="OTP"
                                class="col-8 rounded-tr-0"
                                dir="ltr"
                                type="number"
                                readonly
                              >
                                <template v-slot:append>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon @click="GenerateOTP()" v-on="on">
                                        mdi-flash
                                      </v-icon>
                                    </template>
                                    توليد رمز جديد
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </div>
                          </v-col>
                          <v-col cols="4">
                            <div class="float-left pt-4">
                              اخفاء المتجر
                              <hide-toggler v-model="shopForm.isHidden"></hide-toggler>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-col>
                    <v-col cols="12" class="justify-content-around d-flex">
                      <v-btn
                        rounded
                        class="rounded-tr-0"
                        @click="SubmitSetShop()"
                        :disabled="!valid"
                      >
                        تعديل
                      </v-btn>
                      <v-btn
                        rounded
                        color="IMThemeOrange"
                        outlined
                        class="rounded-tr-0"
                        to="../"
                      >
                        عودة
                      </v-btn>
                      <v-btn
                        rounded
                        color="white"
                        @click="deleteShop()"
                        class="rounded-tr-0"
                      >
                        حذف
                        <img
                          src="/media/svg/table/delete.svg"
                          alt="delete"
                          class="pr-2"
                        />
                      </v-btn>
                    </v-col>
                    <v-col cols="12" class="justify-content-around d-flex">
                      <v-btn
                        @click="sendCode()"
                        dark
                        color="IMThemeOrange"
                        rounded
                        class="rounded-tl-0 px-6"
                        :disabled="disableBtn"
                      >
                        إرسال الرمز
                      </v-btn>
                      <v-btn
                        @click="isShowSMS()"
                        :disabled="disableBtn"
                        dark
                        color="IMThemeOrange"
                        rounded
                        class="rounded-tl-0 px-6"
                      >
                        إرسال رسالة SMS
                      </v-btn>
                    </v-col>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
            <v-card class="mt-4 mx-auto EK-card IMThemeGray rounded-xl rounded-tr-0">
              <v-card-title class="justify-content-center text-white">
                سجل الرسائل المرسلة
              </v-card-title>
              <v-card-text class="text-start">
                <v-simple-table class="scrollable">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th class="text-center">الرسالة</th>
                        <th class="text-center">تاريخ الإرسال</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(record, index) in shopForm.smsRecords" :key="record.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ record.message }}</td>
                        <td>
                          {{ record.sendDate | formatDate }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- <v-col cols="12" lg="3" class="order-lg-1 order-0 text-center mx-auto">
            <div style="max-width: 400px" class="mx-auto">
              <div class="IMThemeOrange text-white p-3 rounded-xl rounded-tl-0 mx-4">
                <h6 class="m-0">الصور الملحقة للمشترك</h6>
                <hide-toggler v-model="formD.hiddenAttributes[24]"></hide-toggler>
              </div>
              <div
                v-for="(img, index) in shopForm.subImages.slice(
                  (imagesPage - 1) * pageSize,
                  (imagesPage - 1) * pageSize + pageSize
                )"
                :key="index"
              >
                <v-card class="mt-6" rounded="xl" :elevation="12">
                    <template v-if="img.state != 2">
                       
                        <v-btn color="error"
                               @click="cancelImg(index + (imagesPage - 1) * pageSize)"
                               type="button"
                               class="rounded-circle AClass">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <hide-toggler v-model="img.isHidden"  class="rounded-circle BClass"></hide-toggler>
                     
                        <img :src="
                        !img
                          ? placeholder
                          : !!img.path
                          ? domainHost + img.path.replace('~', '')
                          : img.base64
                      "
                             :alt="'store image' + index + (imagesPage - 1) * pageSize"
                             class="w-100 border rounded-t-xl"
                             style="object-fit: cover; height: 200px" />
                        <v-textarea class="mb-0"
                                    dense
                                    solo
                                    hide-details
                                    color="IMThemeOrange"
                                    rows="2"
                                    v-model="img.description">
                        </v-textarea>
                    </template>
                </v-card>
              </div>
        
              <div v-if="shopForm.imgSubsState == 1">
                <p class="p-2 text-warning">المشترك ليس لديه اشتراك صور</p>
              </div>
              <div v-else-if="shopForm.imgSubsState == 3 || shopForm.mainSubsState == 3">
                <p class="p-2 text-warning">
                  اشتراك الصور أو اشتراك بطاقة المعلومات لهذا المشترك منتهي
                </p>
              </div>
              <drag-drop-image
                v-else
                title="أضف صور"
                :mul="true"
                @uploaded="uploadSubImgs"
                class="overflow-hidden"
                style="height: 38px; justify-content: flex-end; padding: 7px"
              ></drag-drop-image>
            </div>
          </v-col> -->
        </v-row>
        <v-dialog v-model="showMap" width="1000px" scrollable>
          <map-modal
            @getLatLng="fillLatLng"
            :latProp="shopForm.latitude"
            :lngProp="shopForm.longitude"
            @close="isShowMap()"
          />
        </v-dialog>
        <v-dialog v-model="showSMS" width="1000px">
          <smsModal :Type="1" :Id="shopForm.id" @close="isShowSMS()" />
        </v-dialog>
      </v-container>
    </v-form>
  </div>
</template>
<style lang="scss">
.vbtn{
    margin-top: 20px !important;
    right: 13px !important;
}
.v-text-field__suffix {

  font-size: 12px;
  direction: ltr;
  padding-left: 0 !important;
  padding-right: 4px !important;
}
.v-dialog {
  border-radius: 24px !important;
}
.v-input__append-outer {
  margin-top: 1px !important;
  margin-bottom: 0 !important;
  margin-right: 4px !important;
}
.AClass {
  right: 0;
  position: absolute;
  z-index: 1;
  padding: 7px !important;
  min-width: 0 !important;
}
    .BClass {
        left: 0;
        position: absolute;
        z-index: 1;
        padding: 0px !important;
        min-width: 0 !important;
    }
.v-input .v-label {
  right: 0 !important;
  left: auto !important;
}
.ltr-label .v-label {
  right: auto !important;
  left: 10px !important;
}
.v-label {
  margin: 0 !important;
}
.v-application--is-rtl .v-input--selection-controls__input {
  margin-right: 8px;
}
.v-input--selection-controls .v-input__slot,
.v-input--selection-controls .v-radio {
  flex-direction: row-reverse;
}
.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 4px 5px 2px 0 !important;
}
#mainImg {
  border-radius: 2rem;
}
// .v-menu__content {
//     width: 100px !important;
// }
.image-slider {
  height:400px ;
}
.display-3{ 
  overflow: hidden !important;
  position: relative;
}

</style>
<script>
import actionSchedule from "@/views/pages/setting/components/action-schedule";
import dragDropImage from "@/components/drag-drop-images.vue";
import smsModal from "@/components/smsModal.vue";
import {
  singleImageCompressor,
  multiImageCompressor,
  deleteImage,
} from "@/plugins/fileCompresser.service.js";
import subscriptionState from "@/components/subscription-state.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import loading from "@/components/loading";
import MapModal from "./map-modal";
export default {
  components: {
    dragDropImage,
    subscriptionState,
    loading,
    MapModal,
    actionSchedule,
    smsModal,
  },
  data: () => ({
    imagesPage: 1,
    pageSize: 7,
    selectedCustomDaysWatcher: [],
    s: true,
    selectedCustomDaysMenus: [
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
    ],
    contactInfoType: 7,
    showMap: false,
    disableBtn: false,
    showSMS: false,
    valid: false,
    timeDialog: false,
    selectedPeriod: null,
    dateMenu: false,
    periodsItems: [
      { text: "شهر", value: 1 },
      { text: "شهرين", value: 2 },
      { text: "3 أشهر", value: 3 },
      { text: "4 أشهر", value: 4 },
      { text: "5 أشهر", value: 5 },
      { text: "6 أشهر", value: 6 },
      { text: "7 أشهر", value: 7 },
      { text: "8 أشهر", value: 8 },
      { text: "9 أشهر", value: 9 },
      { text: "10 أشهر", value: 10 },
      { text: "11 شهر", value: 11 },
      { text: "12 شهر", value: 12 },
      { text: "24 شهر", value: 24 },
      { text: "36 شهر", value: 36 },
    ],
    storeName: [(v) => !!v || "يرجى كتابة اسم المشترك"],
    areaId: [(v) => !!v || "يرجى اختيار منطقة"],
    fromTime: [(v) => !!v || "يرجى اختيار وقت بداية"],
    toTime: [(v) => !!v || "يرجى اختيار وقت نهاية"],
    categoriesIds: [(v) => !!v.length || "يرجى اختيار تصنيف واحد على الأقل"],
    otp: [(v) => (v && v.length == 6) || "يرجى توليد رمز تحقق من الأيقونة"],
    link: [(v) => !!v || "يرجى ملأ الحقل"],
    /* eslint-disable */

    email: [
      (v) =>
        !!!v ||
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
          v
        ) ||
        "يرجى كتابة إيميل صحيح",
    ],
  }),
  props: {
    id: String,
  },
  created() {
    this.fetchSchedules().then(() => {
      this.fetchShopDetails(this.id).then(() => {
        this.shopForm.customSchedules.forEach((item) => {
          this.selectedCustomDaysWatcher.push(item.dayofWeek);
        });
      });
    });
    this.fetchSchedulesList();
    //this.fetchSubscriptions();
    this.fetchAreasList();
    this.setBreadcrumbs([
      {
        text: "تفاصيل المشترك",
        href: "/shop",
      },
      {
        text: "تفاصيل المشترك",
        disabled: false,
      },
    ]);
  
  },
  computed: {
    columns() {
      //if (this.$vuetify.breakpoint.xl) {
      //  return 4;
      //}

      //if (this.$vuetify.breakpoint.lg) {
      //  return 3;
      //}

      //if (this.$vuetify.breakpoint.md) {
      //  return 2;
      //}

      return 1;
    },
    ...mapGetters([
      "shopForm",
      "categoriesList",
      "areasList",
      "schedulesList",
      "shopTypes",
      "isLoading",
      "placeholder",
      "domainHost",
      "shopContactInfoType",
      "daysList",
      "shops",
      "subsList",
    ]),
    ...mapState({
      formD: ({ shop }) => shop.shopForm,
    }),
  },
  methods: {
    ...mapActions([
      "setBreadcrumbs",
      "setShop",
      "removeShop",
      "fetchSchedulesList",
      "fetchAreasList",
      "fetchSchedules",
      "fetchShopDetails",
      "unShiftSocial",
      "removeInfoSocial",
      "sendCodeSMS",
      "fetchShops",
      "fetchSubscriptions",
    ]),
    nextPage(page) {
      this.imagesPage = page;
    },
    setOpenClose(day) {
      if (day.is24H) {
        day.open = "00:00";
        day.close = "00:00";
      }
    },
    isShowMap() {
      this.showMap = !this.showMap;
    },
    isShowSMS() {
      this.showSMS = !this.showSMS;
    },
    fillLatLng(lat, lng) {
      this.shopForm.latitude = lat;
      this.shopForm.longitude = lng;
    },
    ChangeEndDate(startDate, selectedPeriod) {
      if (selectedPeriod !== null) {
        const date = new Date(startDate);
        date.setMonth(date.getMonth() + selectedPeriod);
        this.shopForm.subscribeEndDate = new Date(date).toISOString().substr(0, 10);
      }
    },
      SubmitSetShop() {
         // console.log(this.shopForm);
      this.setShop(this.shopForm);
    },
    deleteShop() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: "هل أنت متأكد؟",
          text: "هل فعلاً تريد حذف المشترك ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "نعم!",
          cancelButtonText: "إلغاء",
          reverseButtons: false,
        })
        .then((result) => {
          if (result.value) {
            this.SubmitRemoveShop(this.shopForm);
          }
        });
    },
    SubmitRemoveShop(shopItem) {
      this.removeShop(shopItem);
      this.$router.push({ name: "shop" });
    },
    GenerateOTP() {
      this.shopForm.otp = Math.floor(100000 + Math.random() * 900000);
    },
    uploadMainImg(file) {
      singleImageCompressor(file, this.shopForm.mainImage);
    },
      uploadSubImgs(files) {
     
      multiImageCompressor(files, this.shopForm.subImages);
    },
    cancelImg(index) {
      deleteImage(index, this.shopForm.subImages);
    },
    setAddTimeDialog(val) {
      this.timeDialog = val;
    },
    sendCode() {
      this.sendCodeSMS(this.id);
    },
    goToSub() {
      const index = this.subsList.findIndex((item) => item.shopId == this.shopForm.id);
      let page = Math.ceil((index + 1) / 10);
      this.$router.push("/subscription/" + index);
    },
    ConvertToArabic(number) {
      var regex1 = /^[+]*[(]{0,1}[\u0000-\u007F\u0660-\u0669]{1,3}[)]{0,1}[-\s\./\u0000-\u007F\u0660-\u0669]*$/g;

      if (regex1.test(number))
        this.shopForm.mobileNumber = number.replace(/[٠-٩]/g, (d) =>
          "٠١٢٣٤٥٦٧٨٩".indexOf(d)
        );
    },
  },
  watch: {
    selectedCustomDaysWatcher(newVal, lastVal) {
      if (newVal.length > lastVal.length) {
        this.shopForm.customSchedules.push({
          dayofWeek: newVal[newVal.length - 1],
          open: "00:00",
          close: "00:00",
          shopId: 0,
          is24H: false,
        });
      } else {
        lastVal.forEach((item, index) => {
          if (newVal.indexOf(item) == -1) {
            this.shopForm.customSchedules.splice(index, 1);
          }
        });
      }
    },
  },
};
</script>
